import { Contact } from './contact.model';
import { Address } from './address.model';

export interface OfferTaken {
  make: string;
  model: string;
  applianceCategory: string;
  planNumber: string;
  deliveryDate: string;
  deliveredBy?: string;
  contact: Contact;
  deliveryAddress: Address;
  isDisposalSelected?: boolean;
  isInstallationSelected?: boolean;
  isProtectionSelected?: boolean;
}

export const OfferTaken = undefined;
